import { useEffect, useRef, useState } from "react";
import { Container } from "./style";
import { AuthApi } from "../../api/Auth.api";
import Error from "../../models/Error.model";
import { ERROR_TYPE } from "../../commons/Const";
import { useLocation, useNavigate } from "react-router-dom";

export default function FindIdPage() {

  const navigate = useNavigate()
  const location = useLocation()

  const [uid, setUID] = useState('')
  const tokenRef = useRef('')

  useEffect(() => {
    if(location.state === null) {
      alert('유효하지 않은 접근입니다.')
      navigate({pathname: '/signin'}, {replace: true})
      return
    }

    setUID(location.state.uid)
    tokenRef.current = location.state.token

  }, [location])

  return (
    <Container>
      <div className="inner page_inner">
        <p className="page_title"><span>아이디 찾기</span></p>

        <section>
          <p className="fs16">아이디는 <span className="green">{uid}</span>입니다.</p>

          <button className="contained_main btn_signup"
              onClick={() => {
                window.history.replaceState({}, document.title)
                navigate('/signin')
              }}
            >
              <strong className="fs16">로그인하기</strong>
            </button>
          <button className="contained_main btn_signup"
            onClick={() => {
              window.history.replaceState({}, document.title)
              navigate({pathname: '/reset-password'}, {state: {token: tokenRef.current}})
            }}
          >
            <strong className="fs16">비밀번호 재설정하기</strong>
          </button>
        </section>
      </div>
    </Container>
  )
}